import { useEffect, useMemo, useState } from "react";
import {
  useSakhadConfirmLogin,
  useSakhadGetCaptcha,
  useSakhadLogin,
} from "../../../hook/request/providerSakhad";
import {
  SakhadConfirmInitData,
  SakhadConfirmType,
  SakhadLoginInitData,
  SakhadLoginType,
  SakhadSendOtpInitData,
  SakhadSendOtpType,
} from "../../../types/sakhadAuth";
import { SubmitHandler, useForm } from "react-hook-form";
import { Modal } from "react-bootstrap";
import {
  isHideModalDataSelector,
  isShowModalDataSelector,
  modalDataSelector,
  modalNameSelector,
} from "../../../store/selector/general";
import { connect } from "react-redux";
import { general } from "../../../store/action";
import TextField from "../general/form/textField";

import SakhadOtpTimer from "./SakhadOtpTimer";
import { useGetCaptcha } from "../../../hook/request/auth";
import Icon from "../general/icon";

type SakhadLoginModalProps = {
  modalData: any;
  modalName: string;
  isShowModalData: boolean;
  handleHideModal: any;
  handleResetModal: any;
};

type ModalInfoProps = {
  data?: {
    sessionId: string;
    requestId: string;
    captcha: string;
  };
};

//ورود به سامانه ساخد

const SakhadLoginModal = ({
  modalData,
  modalName,
  isShowModalData,
  handleHideModal,
  handleResetModal,
}: SakhadLoginModalProps) => {
  const [showState, setShowState] = useState(false);
  const [modalInfo, setModalInfo] = useState<ModalInfoProps>({
    data: {
      sessionId: "",
      requestId: "",
      captcha: "",
    },
  });

  const [captcha, setCaptcha] = useState<string>("");

  const [sakhadConfirmResponse, setSakhadConfirmResponse] =
    useState<SakhadConfirmType>(SakhadConfirmInitData);
  const sakhadConfirmRequest = useSakhadConfirmLogin();
  const getSakhadCaptcha = useSakhadGetCaptcha();

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<SakhadConfirmType>({
    defaultValues: useMemo(
      () => sakhadConfirmResponse,
      [sakhadConfirmResponse]
    ),
  });
  const handleSetShowModal = () => {
    if (sakhadConfirmRequest?.isSuccess) {
      setShowState(false);
      handleHideModal();
    }
  };

  const handleSubmitCode: SubmitHandler<SakhadConfirmType> = (data) => {
    sakhadConfirmRequest.mutate({
      answer: data?.answer,
    });
  };

  useEffect(() => {
    setCaptcha(
      `data:image/png;base64,${getSakhadCaptcha?.data?.data?.result?.captcha}`
    );
    if (getSakhadCaptcha?.isSuccess) {
      handleSetShowModal();
    }
  }, [getSakhadCaptcha?.data?.data?.result]);

  const refreshCaptcha = () => {
    getSakhadCaptcha.mutate(undefined);
    reset();
  };
  useEffect(() => {
    if (isShowModalData && modalName == "sakhadLoginModal") {
      setShowState(true);
      setModalInfo(modalData);
      setCaptcha(`data:image/png;base64,${modalData?.data?.captcha}`);
      handleResetModal();
    }
  }, [modalData, modalName]);

  return (
    <Modal
      show={showState}
      onHide={handleSetShowModal}
      centered
      bodyClassName="p-0" // Control padding from inside the form-box now
    >
      <div className="captcha-modal-content w-100 mw-100 mx-auto py-3">
        <div className="d-flex align-items-center justify-content-between mb-4 fs-3 px-4">
          <h4 className="title-dot font-16 font-weight-bold mb-0">
            تایید کد کپچا
          </h4>
          <button
            type="button"
            className="btn-close-modal text-red-hover p-0 border-0 bg-transparent"
            onClick={handleSetShowModal}
            aria-label="بستن"
          >
            <Icon name="close-square" />
          </button>
        </div>
        <form onSubmit={handleSubmit(handleSubmitCode)}>
          <div className="px-4">
            <div className="form-group mb-4">
              <label className="inp-lbl me-2 mb-2" htmlFor="captcha-answer">
                لطفاً کد کپچا زیر را وارد نمایید.
              </label>
              <div className="captcha-image-wrapper mb-3 text-center">
                {captcha ? (
                  <img
                    src={captcha}
                    alt="کد کپچا"
                    className="border rounded inline-block p-2 max-w-full h-auto"
                  />
                ) : (
                  <div className="text-muted">در حال بارگذاری کپچا...</div>
                )}
                {/* <span onClick={refreshCaptcha}>
                  <a className="d-flex align-items-center justify-content-center btn btn-outline-primary rounded rounded-3  text-black p-2">
                    <Icon name="refresh" />
                  </a>
                </span> */}
                <button
                  type="button"
                  className="btn-green text-blue-hover m-1 border-0  bg-transparent"
                  onClick={refreshCaptcha}
                  aria-label="کپچا جدید"
                >
                  <Icon name="refresh" />
                </button>
              </div>
              <TextField
                name="answer"
                id="captcha-answer" // Added id to match label
                placeholder="کد کپچا را وارد کنید"
                control={control}
                error={errors} // Passed errors for RHF validation messages
                className="ltr font-en text-center" // Centered text for better captcha input
              />
              <div className="mb-4 text-center">
                <button
                  type="button"
                  onClick={refreshCaptcha}
                  className="btn btn-link text-blue-600 mt-2 p-0" // Using btn-link for consistent styling
                >
                  دریافت مجدد کپچا
                </button>
              </div>
            </div>
          </div>

          <div className="d-flex px-4 gap-3">
            <div className="ms-auto d-flex gap-3">
              {/* <button
                type="button"
                className="btn btn-outline-secondary rounded-4 px-4 py-2"
                onClick={handleSetShowModal}
                disabled={sakhadConfirmRequest.isPending}
              >
                لغو
              </button> */}
              <button
                type="submit"
                className="btn btn-primary rounded-4 px-4 py-2"
                disabled={sakhadConfirmRequest.isPending}
              >
                {sakhadConfirmRequest.isPending ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    در حال ارسال...
                  </>
                ) : (
                  "ارسال"
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};
const mapStateToProps = (state: any) => ({
  modalData: modalDataSelector(state),
  modalName: modalNameSelector(state),
  isShowModalData: isShowModalDataSelector(state),
  isHideModalData: isHideModalDataSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  handleHideModal: () => dispatch(general.handleHideModal()),
  handleResetModal: () => dispatch(general.handleResetModal()),
});
export default connect(mapStateToProps, mapDispatchToProps)(SakhadLoginModal);
